import React from "react";
import Navbar from "../components/Navbar";
import "../styles/Contact.css";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";

function Contact() {

  const handleSubmit = async (e) => {
    e.preventDefault(); // 🚫 stops Formspree redirect

    const form = e.target;

    const formData = new FormData(form);

    try {
      const response = await fetch("https://formspree.io/f/xzdkwabp", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      if (response.ok) {
        alert("Message sent successfully!");
        form.reset(); // clear form
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      alert("Error sending message.");
    }
  };

  return (
    <div>
      <Navbar />

      <section className="contact">
        <h1>Contact Us</h1>
        <p className="subtitle">
          Get in touch with Bomander Travels Limited
        </p>

        <div className="contact-container">

          
          <form
            onSubmit={handleSubmit}
            className="contact-form"
          >
            <input type="text" name="name" placeholder="Your Name" required />
            <input type="email" name="email" placeholder="Your Email" required />
            <textarea name="message" placeholder="Your Message" required></textarea>
            <button type="submit">Send Message</button>
          </form>

          
          <div className="contact-info">

            <a href="mailto:Admin@bomander.com" className="contact-link">
              <FaEnvelope className="icon email-icon" />
              Admin@bomander.com
            </a>

            <a
              href="https://wa.me/2348103336533"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link whatsapp"
            >
              <FaWhatsapp className="icon whatsapp-icon" />
              Chat on WhatsApp
            </a>

          </div>

        </div>
      </section>
    </div>
  );
}

export default Contact;